import { render, staticRenderFns } from "./OfferWeek.vue?vue&type=template&id=27dfc248&"
import script from "./OfferWeek.vue?vue&type=script&lang=js&"
export * from "./OfferWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports